import { componentQrl, inlinedQrl, _jsxQ, _fnSignal } from "@builder.io/qwik";
const InlinedScript = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  return /* @__PURE__ */ _jsxQ("script", null, {
    dangerouslySetInnerHTML: _fnSignal((p0) => p0.scriptStr, [
      props
    ], "p0.scriptStr"),
    "data-id": _fnSignal((p0) => p0.id, [
      props
    ], "p0.id"),
    nonce: _fnSignal((p0) => p0.nonce || "", [
      props
    ], 'p0.nonce||""')
  }, null, 3, "WO_0");
}, "InlinedScript_component_hwThBdhA8rw"));
export {
  InlinedScript,
  InlinedScript as default
};
